import useTranslation from 'next-translate/useTranslation'
import { useRouter } from 'next/router'
import React, { FC, useEffect, useState } from 'react'
import { FlexboxGrid } from 'rsuite'

import { getMainHeading } from '../../lib/catalog'
import useUrls from '../../services/useUrls'
import { getCountryAndLocaleStrings } from '../../utils/locales'
import useCategoryDataStructure from '../hooks/useCategoryDataStructure'
import { CatalogType } from '../../utils/types/misc'
import { QueryParam, ScreenSize } from '../../utils/constants'
import EmptySearchButton from './Header/EmptySearchButton'
import CategorySidebarAdBanner from '../AdBanners/CategorySidebarAdBanner'
import useIsOnMobile from '../../services/useIsOnMobile'

import styles from '../../styles/ProductCatalog.module.less'

interface CatalogLayoutProps {
  catalogTab: CatalogType
}

const CatalogLayout: FC<CatalogLayoutProps> = (props) => {
  const { catalogTab } = props

  const { query, prefetch } = useRouter()
  const { t, lang: countryAndLang } = useTranslation('products')
  const { urlT } = useUrls()
  const { subCategory } = useCategoryDataStructure()
  const isOnMobile = useIsOnMobile(ScreenSize.md)

  const [activeTab, setActiveTab] = useState<CatalogType>('products')

  const searchQuery = query[QueryParam.search]
  const { locale: lang } = getCountryAndLocaleStrings(countryAndLang)

  useEffect(() => {
    if (catalogTab !== activeTab) setActiveTab(catalogTab)
    // Pre fetch tab switching
    prefetch(urlT(catalogTab === 'products' ? '/suppliers' : '/products'))
  }, [catalogTab])

  return (
    <>
      {isOnMobile && <CategorySidebarAdBanner />}

      <FlexboxGrid
        className={`margin-left-zero margin-right-zero ${styles['catalog-heading-area']}`}
        align="middle"
      >
        <FlexboxGrid.Item className="padding-zero margin-right-spacer-double flex-shrink-1">
          <h1 className={isOnMobile ? 'margin-top-spacer-double' : ''}>
            {getMainHeading(catalogTab, query, t, lang, subCategory)}
          </h1>
          {catalogTab === 'suppliers' && !searchQuery && (
          <p className={`${styles['catalog-header-subheader']} margin-top-spacer-double`}>
            {t('More than 100 European brands on one wholesale marketplace')}
          </p>
          )}
        </FlexboxGrid.Item>
        <FlexboxGrid.Item>
          {searchQuery && (
          <EmptySearchButton />
          )}
        </FlexboxGrid.Item>
      </FlexboxGrid>
    </>
  )
}

export default CatalogLayout
